let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7rvD3")).then(() => parcelRequire('91UgQ'));